<template>
  <div :class="classnames">
    <open-modal-control :view="'modal-view-search'" :props="{}">
      <VueButton direction="rtl">
        <template slot="text">Search</template>
        <template slot="icon">
          <SvgIconSearch />
        </template>
      </VueButton>
    </open-modal-control>
  </div>
</template>

<script>
  import InteractiveSvgIcon from '@/components/InteractiveSvgIcon'
  import OpenModalControl from '@/components/OpenModalControl'
  import SvgIconSearch from '@/svgs/SvgIconSearch'
  import VueButton from '@/components/VueButton'
  import SvgIconMagnifyingGlass from '@/svgs/SvgIconMagnifyingGlass'

  import { bem } from '@/mixins/bem.js'

  const namespace = 'toolbar-search-button'

  export default {
    name: 'ToolbarSearchButton',
    components: {
      'interactive-svg-icon': InteractiveSvgIcon,
      'open-modal-control': OpenModalControl,
      'svg-icon-magnifying-glass': SvgIconMagnifyingGlass,
      VueButton,
      SvgIconSearch
    },
    mixins: [ bem ],
    data () {
      return {}
    },
    created: function () {
      this.namespace = namespace
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/ToolbarSearchButton.vue